import { createScriptIn } from './ui_utils/DomUtils.ts';
import { UIUtilsEjsVariables } from './UIUtilsEjsVariables.ts';
import { ClientUserState } from './ClientUserState.ts';
import { UserSessionUtils } from './UserSessionUtils.ts';
export class ValueImpressionLoader {
    static init() {
        var _ClientUserState_userState, _ClientUserState_userState1;
        if (this.initialized) return;
        if (UIUtilsEjsVariables.vliPublicKey == '') return;
        if (UIUtilsEjsVariables.vliAdvKey == '') return;
        if (window['vitag'] == undefined) return; // only set on pages where ads can be displayed
        if (window.location.hostname === 'localhost') return;
        if (UIUtilsEjsVariables.isUserOnDiscord) return;
        if (UIUtilsEjsVariables.isUserOnMobile && UIUtilsEjsVariables.shouldHideAdsOnMobile) return;
        if (ClientUserState.isStale()) return;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hideAds()) return;
        window['hashString'] = (_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.vliHash;
        createScriptIn(document.body, UIUtilsEjsVariables.vliPublicKey);
        createScriptIn(document.body, UIUtilsEjsVariables.vliAdvKey);
        createScriptIn(document.body, '//cdn.jsdelivr.net/gh/vli-platform/adb-analytics@77bebb/v1.0.min.js');
        document.querySelectorAll('.remove_ads_button_in_game').forEach((element)=>element.classList.remove('hidden'));
        const shouldShowLobbyAds = UserSessionUtils.shouldShowLobbyAds();
        if (shouldShowLobbyAds) {
            document.querySelectorAll('.vli_page_vertical_ad').forEach((element)=>element.classList.remove('hidden'));
            document.querySelectorAll('.main_page_ad_300x100').forEach((element)=>element.classList.remove('hidden'));
            document.querySelectorAll('.main_page_ad_300x250').forEach((element)=>element.classList.remove('hidden'));
            document.querySelectorAll('.mm-mode-selector-ad').forEach((element)=>element.classList.remove('hidden'));
        }
        document.querySelectorAll('.adsbyvli').forEach((element)=>element.classList.remove('hidden'));
        this.initialized = true;
    }
}
ValueImpressionLoader.initialized = false;
